import React from 'react';

const Flag = ({ countryCode, locale, size, rounded, square }) => {
  let code = countryCode;
  if (locale) {
    try {
      const parsedLocale = new Intl.Locale(locale.replaceAll('_', '-'));
      code = parsedLocale.region || parsedLocale.maximize().region;
    } catch {
      code = undefined;
    }
  }

  return (
    code ? <span aria-hidden="true" className={`fp ${code.toLowerCase()} ${size ? `fp-${size}` : ''} ${rounded ? 'fp-rounded' : ''} ${square ? 'fp-square' : ''}`} /> : null
  );
};

export default Flag;
